import { render, staticRenderFns } from "./additionalList.vue?vue&type=template&id=3233f0f8&scoped=true"
import script from "./additionalList.vue?vue&type=script&lang=js"
export * from "./additionalList.vue?vue&type=script&lang=js"
import style0 from "./additionalList.vue?vue&type=style&index=0&id=3233f0f8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3233f0f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3233f0f8')) {
      api.createRecord('3233f0f8', component.options)
    } else {
      api.reload('3233f0f8', component.options)
    }
    module.hot.accept("./additionalList.vue?vue&type=template&id=3233f0f8&scoped=true", function () {
      api.rerender('3233f0f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/insuranceManage/additionalList.vue"
export default component.exports